import {Routes} from '@angular/router';
import {signOutGuard} from './_guards/sign-out.guard';
import {verifyGuard} from './_guards/verify.guard';
import {authenticationGuard} from './_guards/authentication.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [signOutGuard],
    loadChildren: () => import('./_public/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'password',
    canActivate: [signOutGuard],
    loadChildren: () => import('./_public/password/password.module').then(m => m.PasswordModule)
  },
  {
    path: 'verify-code',
    canActivate: [verifyGuard],
    loadChildren: () => import('./_public/verify-code/verify-code.module').then(m => m.VerifyCodeModule)
  },
  {
    path: 'forgot-password',
    canActivate: [signOutGuard],
    loadChildren: () => import('./_public/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'secure',
    canActivate: [authenticationGuard],
    loadChildren: () => import('./_secure/secure.module').then(m => m.SecureModule)
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "secure",
  },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: "secure",
  },
];
